import React, { useState } from 'react';

const ContactSection = () => {
  return (
    <div>
      <section id="about" className="jarallax text-light">
        <div className="center-y relative text-center">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h1 className="text-white">Contact Us</h1>
              </div>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>
      </section>

      <div className="section-full p-t150 p-b120 site-bg-white twm-contact-section-wrap">
        <div className="container">
          <div className="section-content">
            <div className="twm-contact-section">
              <div className="row ">
                {/* Contact Info Section */}
                <div className="col-12">
                  <div className="twm-maskingtext m-b50">
                    <h1>Get In Touch</h1>
                    <img src="images/text-masking-pic.jpg" alt="Image" />
                  </div>
                </div>
                <div className="twm-get-info-wrap ">
                  <ul className="row">
                    {/* Phone */}
                    <li className="col-12 col-md-4">
                      <div className="twm-get-info">
                        <div className="twm-media">
                          <i className="feather feather-phone-call"></i>
                        </div>
                        <div className="twm-content">
                          <p>Phone</p>
                          <h3 className="twm-title">
                            <a href="tel:+918624029699">+91 8624029699</a> <br></br>
                          </h3>
                        </div>
                      </div>
                    </li>

                    {/* Email */}
                    <li className="col-12 col-md-4 ">
                      <div className="twm-get-info">
                        <div className="twm-media">
                          <i className="feather feather-mail"></i>
                        </div>
                        <div className="twm-content">
                          <p>Email</p>
                          <a href="mailto:booking@abghulecabs.com">
                            <h4>booking@abghulecabs.com</h4>
                            </a>

                        </div>
                      </div>
                    </li>

                    {/* Address */}
                    <li className="col-12 col-md-4">
                      <div className="twm-get-info">
                        <div className="twm-media">
                          <i className="feather feather-home"></i>
                        </div>
                        <div className="twm-content">
                          <p>Address</p>
                          <h3 className="twm-title"> A B Ghule Enterprises <br/> (A B Ghule Cabs)
                          <br/>R -10 Office No  -1606,<br/>
                          Life Republic Mulshi,<br></br> Marunji 
                         Pune,
                          Maharashtra <br></br>- 411057.
                          </h3>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="gmap-outline">
                <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3145.6343987283462!2d73.22422897520734!3d19.157061282064316!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTnCsDA5JzI1LjQiTiA3M8KwMTMnMzYuNSJF!5e1!3m2!1sen!2sin!4v1734777390655!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

            </div>
    </div>
  );
};

export default ContactSection;
